import { render } from "./ProjectBody.vue?vue&type=template&id=42325095&scoped=true"
import script from "./ProjectBody.vue?vue&type=script&lang=js"
export * from "./ProjectBody.vue?vue&type=script&lang=js"

import "./ProjectBody.vue?vue&type=style&index=0&id=42325095&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42325095"]])

export default __exports__